module.exports = __webpack_public_path__ + "static/img/CY.6b3c3f41.jpg";